module.exports = __webpack_public_path__ + "static/media/MainInfo.c068ef8b.svg";